import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaLoyaltyProgramBonusFollowup } from 'src/app/assabil-sales/models/dtos/geo-area-loyalty-program-bonus-followup';

@Component({
  selector: 'geo-area-loyalty-program-bonus-followup',
  templateUrl: './geo-area-loyalty-program-bonus-followup.component.html',
  styleUrls: ['./geo-area-loyalty-program-bonus-followup.component.scss']
})
export class GeoAreaLoyaltyProgramBonusFollowupComponent implements OnInit {


  @Input() geoAreaLoyaltyProgramBonusFollowup : GeoAreaLoyaltyProgramBonusFollowup;

  @Output() onClick        = new EventEmitter<any>();

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaLoyaltyProgramBonusFollowup.expanded = !this.geoAreaLoyaltyProgramBonusFollowup.expanded;
  }
}